export type PreviewApiResponse = {
  ok?: boolean;
  detected_format?: string;
  warnings?: string[];
  endpoints?: unknown;
  spec?: {
    title?: string;
    description?: string;
    base_url?: string;
    total_endpoints?: number;
    auth_schemes?: Array<{ type?: string; name?: string; scheme?: string }>;
  };
  report?: {
    issues?: Array<{ message?: string }>;
  };
};

export function assertPreviewResponse(data: unknown): PreviewApiResponse {
  if (!data || typeof data !== "object") {
    throw new Error("Preview failed. The converter API returned an invalid response.");
  }

  const body = data as PreviewApiResponse;
  if (!Array.isArray(body.endpoints)) {
    throw new Error(
      "Preview failed. The converter API is not available on this host. Try again after the latest deploy finishes.",
    );
  }

  return body;
}

export function zeroEndpointMessage(raw: PreviewApiResponse): string | null {
  if (!Array.isArray(raw.endpoints) || raw.endpoints.length > 0) return null;

  const fromWarnings = raw.warnings?.map((w) => w.trim()).filter(Boolean).join(" ");
  if (fromWarnings) return fromWarnings;

  const description = raw.spec?.description?.trim();
  if (description && description !== raw.spec?.title?.trim()) return description;

  const issue = raw.report?.issues?.[0]?.message?.trim();
  if (issue) return issue;

  return "No endpoints were found. Use OpenAPI/Swagger with a paths section, or a Postman collection with requests.";
}
